import styled from 'styled-components';

export const FilmstripClickableTile = styled.div`
  cursor: pointer;
  outline: none;
`;
